'use client';
import { Button } from '@ahafood/ui/components/button';
import { ArrowLeft } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { getDealFn } from '@/api/ahafood/get-deal-fn';
import { useRouter } from '@/i18n/routing';

type Props = {
  campaignId?: string;
  city?: string;
};

export default function CampaignSession({ campaignId, city }: Props) {
  const router = useRouter();
  const [deals, setDeals] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDeals = async () => {
      try {
        const result = await getDealFn({
          city_id: city ?? '',
          skip: 0,
          limit: 100,
        });
        setDeals(result);
      } catch (error) {
        setDeals(null);
      } finally {
        setLoading(false);
      }
    };
    void fetchDeals();
  }, [city]);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-6">
        <p>Đang tải...</p>
      </div>
    );
  }

  const tag = deals?.tags?.find((t: any) => t._id === Number(campaignId));
  if (!tag)
    return (
      <>
        <div className="container mx-auto px-4 py-6">
          <Button
            variant="ghost"
            className="text-sm font-medium px-1"
            onClick={() => router.back()}
          >
            <ArrowLeft />
          </Button>
          <h1 className="text-3xl font-bold mt-4 mb-2">
            Chiến dịch không tồn tại
          </h1>
          <p className="mb-6 neutral-60">Vui lòng thử lại sau.</p>
        </div>
      </>
    );

  return (
    <div className="container mx-auto p-0">
      <div className="flex items-center justify-between h-10 text-center mb-2">
        <Button
          variant="ghost"
          className="text-sm font-medium px-1 [&_svg]:size-5"
          onClick={() => router.back()}
        >
          <ArrowLeft />
        </Button>
        <h1 className="text-xl font-bold">{tag.title_vi_vn}</h1>
        <div className="w-8">{/* Placeholder for alignment */}</div>
      </div>
      <img
        src={tag.icon_image_url || '/static/images/empty-store.webp'}
        alt={tag.title_vi_vn}
        className="w-full h-40 md:h-80 object-cover rounded-lg mb-4"
      />
      <p className="mb-6 text-neutral-60">{tag.description_vi_vn}</p>
    </div>
  );
}
